import QuestionButtonNav from "components/QuestionButtonNav"
import React, { useState } from "react"
import { useDispatch } from "react-redux"
import { learningDevelopmentActions } from "redux/L&D/slice/user"

const tabItems = {
  ADD_QUESTION: "ADD",
  GENERATE_QUESTION: "GENERATE",
  AUTO_SUGGEST: "AUTO"
}

function QuestionNavBar(props) {
  const [menu] = useState(menuNav)
  const dispatch = useDispatch()

  function handleButtonNav(item) {
    dispatch(learningDevelopmentActions.setQuestionMenuLink(item))
  }

  return (
    <>
      {menu?.map((item, i) => {
        return (
          <QuestionButtonNav
            style={{ marginRight: 12 }}
            onPress={() => handleButtonNav(item?.value)}
            key={i}
            isActive={props.activeTab === item.value ? true : false}>
            {item.name}
          </QuestionButtonNav>
        )
      })}
    </>
  )
}

export default QuestionNavBar

const menuNav = [
  {
    name: "Add Question",
    isActive: true,
    value: tabItems?.ADD_QUESTION
  },
  {
    name: "Generate Question",
    isActive: false,
    value: tabItems?.GENERATE_QUESTION
  },
  {
    name: "Auto Suggestion",
    isActive: false,
    value: tabItems?.AUTO_SUGGEST
  }
]
